// External Dependencies:
import 'babel-polyfill'
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { TransitionGroup } from 'react-transition-group'
import objectFitImages from 'object-fit-images'
import i18n from 'i18n-calypso'

// Internal Dependencies:
import HomeLayout from 'layouts/main/HomeLayout'
import PageLayout from 'layouts/main/PageLayout'
import PageTracker from 'components/PageTracker/PageTracker'
import { doRequest } from 'utilities/request'
const locale = siteData.default_locale

// Redux:
import { Provider } from 'react-redux'
import configureStore from 'store/configure-store'
const store = configureStore()

// Polyfills:
import 'es6-promise/auto'
import 'unfetch/polyfill'
objectFitImages()

function renderSite( localeData ) {
	ReactDOM.render(
		<Provider store={ store }>
			<BrowserRouter>
				<TransitionGroup transitionName="page-transition" transitionEnterTimeout={ 500 } transitionLeaveTimeout={ 500 }>
					<Switch>
						<Route path="/" exact component={ PageTracker( HomeLayout ) } />

						<Route path="/:page" exact component={ PageTracker( PageLayout ) } />
						<Route path="/:parent/:page" exact component={ PageTracker( PageLayout ) } />
						<Route component={ PageLayout } />
					</Switch>
				</TransitionGroup>
			</BrowserRouter>
		</Provider>,

		document.getElementById( 'app' )
	)
}

// Attempt to load the locale file:
if ( siteData.skip_locale_load ) {
	// Load:
	renderSite()
} else {
	// Get the locale file, then load:
	doRequest( `${siteData.languages_url}${locale}.json?v=${siteData.version}` )
		.then( json => {
			// Load the locale.
			i18n.setLocale( json )

			renderSite()
		})
		.catch( error => {
			// If there is an error loading the locale, use the default.
			renderSite()
		})
}



// WEBPACK FOOTER //
// ./app.jsx